import WPBlockVimeoEmbed from "./WPBlockVimeoEmbed.js";
import WPBlockYouTubeEmbed from "./WPBlockYouTubeEmbed.js";

const ACFBlockVideoOverlay = (domEl) => {

	const btn = domEl.querySelector('.enhanced-play-btn');
	if(!btn) {
		return;
	}

	let videoEmbed;

	const handleBtnClicked = (e) => {
		e.preventDefault();

		videoEmbed = domEl.querySelector('.wp-block-embed').cloneNode(true);
		videoEmbed.querySelector('.placeholder').setAttribute('id', videoEmbed.querySelector('.placeholder').getAttribute('id') + '-' + Math.random());

		const lightbox = document.querySelector('#lightbox');
		lightbox.querySelector('.lightbox-placeholder').innerHTML = '';
		lightbox.querySelector('.lightbox-placeholder').appendChild(videoEmbed);

		if(domEl.dataset.vendor === 'vimeo') {
			new WPBlockVimeoEmbed(videoEmbed, true);
		}
		else if(domEl.dataset.vendor === 'youtube') {
			new WPBlockYouTubeEmbed(videoEmbed, true);
		}

		document.addEventListener('LIGHTBOX_CLOSED', handleLightboxClosed);
		document.body.classList.add('js-lightbox-revealed');
	}

	const handleLightboxClosed = () => {
		if(videoEmbed) {
			videoEmbed.parentNode.removeChild(videoEmbed);
		}
	}

	btn.addEventListener('click', handleBtnClicked);
};

export default ACFBlockVideoOverlay;